import api from './api';
import logger from '../utils/logger';

const passwordResetService = {
  // User requests password reset
  forgotPassword: async (email) => {
    try {
      const response = await api.post('/api/auth/forgot-password', { email });
      return response.data;
    } catch (error) {
      logger.error('Forgot password error:', error);
      throw error;
    }
  },

  // Validate reset token
  validateResetToken: async (token) => {
    try {
      const response = await api.get(`/api/auth/reset-password/${token}`);
      return response.data;
    } catch (error) {
      logger.error('Token validation error:', error);
      throw error;
    }
  },

  // Complete password reset
  resetPassword: async (token, newPassword) => {
    try {
      const response = await api.post('/api/auth/reset-password', {
        token,
        new_password: newPassword
      });
      return response.data;
    } catch (error) {
      logger.error('Reset password error:', error);
      throw error;
    }
  },

  // User changes own password
  changePassword: async (currentPassword, newPassword) => {
    try {
      const response = await api.post('/api/users/me/change-password', {
        current_password: currentPassword,
        new_password: newPassword
      });
      return response.data;
    } catch (error) {
      logger.error('Change password error:', error);
      throw error;
    }
  },

  // Update user settings
  updateSettings: async (settings) => {
    try {
      const response = await api.put('/api/users/me/settings', settings);
      return response.data;
    } catch (error) {
      logger.error('Update settings error:', error);
      throw error;
    }
  },

  // Get user's tenant info
  getTenantInfo: async () => {
    try {
      const response = await api.get('/api/users/me/tenant');
      return response.data;
    } catch (error) {
      logger.error('Get tenant info error:', error);
      throw error;
    }
  },

  // Admin triggers password reset for user
  adminResetPassword: async (email) => {
    try {
      const response = await api.post(`/api/users/${email}/reset-password`);
      return response.data;
    } catch (error) {
      logger.error('Admin reset password error:', error);
      throw error;
    }
  },

  // Admin updates user
  updateUser: async (userId, userData) => {
    try {
      const response = await api.put(`/api/users/${userId}`, userData);
      return response.data;
    } catch (error) {
      logger.error('Update user error:', error);
      throw error;
    }
  }
};

export default passwordResetService;
